import React, { useEffect } from 'react'
import { useVeille } from '../../redux/Hooks';
import { defaultTimeoutMilliseconds } from '../../model/Configuration';

const ScreenSaver = (props: {
	switchComponent: Function,
	loop: boolean
}) => {
	const veille = useVeille();

	useEffect(() => {
		var timer: any = null;
		if(!props.loop) {
			timer = setTimeout(() => {
				props.switchComponent();
			}, veille?.screenSaver?.timeBeforeSwitch ? veille?.screenSaver?.timeBeforeSwitch * 1000 : defaultTimeoutMilliseconds);
		}

		return () => timer && clearTimeout(timer)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div
			className='h-full w-full'
			style={{
				backgroundImage: `url(${veille?.screenSaver?.source})`,
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover'
			}}
		/>
	)
}

export default ScreenSaver;